<script lang="ts">
	import type { FlickityOptions as Options } from "$lib/serv/vendor-integration/splide";
  	
	import { Vertical } from '$lib/def/verticals';

  import Carousel from "$lib/ui/layout/Carousel.svelte";
  import SeoBrandItem from "./SeoBrandItem.svelte";

	type Brand = {name?:string, vertical?:string, description?:string, banner?:string, logo?:string};

	export let brands: undefined | Brand[];
	export let title: string = 'Hungry for a deal?'

	let options: Options = {
		draggable: true,
		selectedAttraction: 0.025,
		friction: 0.28,
		adaptiveHeight: true,
		groupCells: true
	}

</script>

{#if brands}
	<Carousel cache={{payload: brands}} type="seo-brands" let:item={item} key={() => brands?.filter(b => b.vertical === Vertical.Restaurant || !b.vertical) as Brand[]}>
		<h3 slot="title" class="title headline-m bold">{title}</h3>
		<SeoBrandItem {item} />
	</Carousel>
{/if}